import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

import ContactIcons from '../Contact/ContactIcons';
import { fadeUp, fadeIn } from '../../utils/motion';

const { PUBLIC_URL } = process.env; // set automatically from package.json:homepage

const SideBar = () => (
  <motion.aside id="sidebar" variants={fadeUp} initial="hidden" animate="visible">
    <motion.div className="sidebar-panel" variants={fadeUp}>
      <motion.section id="intro" variants={fadeUp}>
        <Link to="/" className="logo">
          <img src={`${PUBLIC_URL}/images/me.jpg`} alt="" />
        </Link>
        <header>
          <h2>Yasin Boelhouwer</h2>
          <p>
            <a href="mailto:info@yasin.nu">info@yasin.nu</a>
          </p>
        </header>
      </motion.section>

      <motion.section className="blurb" variants={fadeIn}>
        <h2>About</h2>
        <p>
          Hi, I&apos;m Yasin. I am an
          experienced product manager specializing in domains,
          SSL, and Web3 innovation. With over a decade of experience
          in the domains industry, I have driven success through strategic partnerships,
          large-scale migrations, and innovative product development.

        </p>
        <ul className="actions">
          <li>
            {!window.location.pathname.includes('/resume') ? (
              <Link to="/resume" className="button">
                Learn More
              </Link>
            ) : (
              <Link to="/about" className="button">
                About Me
              </Link>
            )}
          </li>
        </ul>
      </motion.section>
    </motion.div>

    <motion.section id="footer" variants={fadeIn}>
      <ContactIcons />
      <p className="copyright">
        &copy; Yasin Boelhouwer <Link to="/">yasin.nu</Link>.
      </p>
    </motion.section>
  </motion.aside>
);

export default SideBar;
